import { withStore } from 'store';
import { withLayout } from 'hocs';
import MyCompanionAddLanding  from './MyCompanionAddLanding';

export default withLayout(
  withStore(
    {
      mapStateToProps: (state) => ({
        tableInfo: state.giftTable.giftTable
      }),
    },
    //actions
  )(MyCompanionAddLanding)
);
